import React, {Component, Fragment} from 'react';
import {Button, Card, CardBody, CardTitle, Row} from 'reactstrap';
import {withTranslation} from 'react-i18next';
import {Colxx, Separator} from '../../../../components/common/CustomBootstrap';
import moment from 'moment';
import {
  i18nizeDate,
  numberWithCommas,
  getStatusColor,
  mapStatus,
  mapWithdrawError,
} from '../../../../helpers/Utils';
import {application, baseTokenSymbol, reactTableText} from '../../../../constants/configs';
import TransactionDetails from '../../../../containers/TransactionDetails';
import WithdrawsOutputForm from '../../../../containers/WithdrawsOutputForm';
import ModalManager from '../../../../components/modal/ModalManager';
import Breadcrumb from '../../../../containers/navs/Breadcrumb';
import ToolTip from '../../../../components/ToolTip';
import ReactTable from 'react-table';
import Api from '../../../../services/Api';
import {Link} from 'react-router-dom';
import {store} from '../../../../AppRenderer';
import {keyBy, mapValues, omit, values} from 'lodash';
import ReactTableSelectFilter from '../../../../components/ReactTableSelectFilter';
import ReactTableDateFilter from '../../../../components/ReactTableDateFilter';
import {NotificationManager} from '../../../../components/common/react-notifications';
import Rbac from "../../../../components/Rbac";

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      withdraws: [],
      pages: -1,
      loading: false,
      refreshing: false,
      selectedStartDate: null,
      selectedEndDate: null,
      expanded: {},
    };
    this.tokens = keyBy(store.getState().general.tokens, 'symbol');
    this.networks = store.getState().app.networks;
    this.renderTokenFilter = this.renderTokenFilter.bind(this);
    this.renderStatusFilter = this.renderStatusFilter.bind(this);
    this.renderDateFilter = this.renderDateFilter.bind(this);
  }

  fetchWithdraws = async state => {
    try {
      const offset = state.page * state.pageSize;
      const {data} = await Api.invoke(
        'GET',
        '/admin-ui/users-withdraws',
        null,
        {
          params: {
            offset,
            limit: state.pageSize,
            ...(state.filtered.length ? omit(mapValues(keyBy(state.filtered, 'id'), 'value'), 'timestamp') : null),
            ...(this.state.selectedStartDate ? {from: moment(this.state.selectedStartDate).toISOString()} : null),
            ...(this.state.selectedEndDate ? {to: moment(this.state.selectedEndDate).toISOString()} : null),
          },
        },
      );
      this.setState({
        withdraws: data.withdraws,
        pages: data.totalPage,
      });
    } catch (e) {
      console.log('error: ', e);
    }
  };

  fetchData = async state => {
    this.setState({loading: true});
    await this.fetchWithdraws(state);
    this.setState({loading: false});
  };

  getColumns = t => [
    {
      Header: t('First Name'),
      accessor: 'firstName',
      width: 100,
    },
    {
      Header: t('Last Name'),
      accessor: 'lastName',
      width: 150,
    },
    {
      Header: t('Email'),
      accessor: 'email',
    },
    {
      Header: t('Amount'),
      accessor: 'amount',
      Cell: props => {
        if (props.original.token === baseTokenSymbol) {
          const fee = this.networks[baseTokenSymbol].supportedTokens[baseTokenSymbol].withdraw.withdrawalFeePolicy.value;
          return (
            <div className="d-flex flex-column">
              <div>{`${t('withdraw amount')}: ${numberWithCommas(Number(props.value))}`}</div>
              <div>{`${t('withdraw fee')}: ${numberWithCommas(fee)}`}</div>
              <div>{`${t('Net amount paid')}: ${numberWithCommas(Number(props.value) - Number(fee))}`}</div>
            </div>
          );
        }
        return (
          <span>{numberWithCommas(Number(props.value))}</span>
        );
      },
    },
    {
      Header: t('Token'),
      accessor: 'token',
      filterable: true,
      Filter: this.renderTokenFilter,
      width: 160,
      Cell: props => <span>{this.tokens[props.value] ? this.tokens[props.value].localeName : props.value}</span>,
    },
    {
      Header: t('Status'),
      accessor: 'status',
      filterable: true,
      width: 130,
      Filter: this.renderStatusFilter,
      Cell: props => <div>
        <span className={getStatusColor(props.value)}>{mapStatus(props.value)}</span>
        {props.value === 'REJECTED' &&
        !!props.original.error ?
          <ToolTip id={props.original.id} text={mapWithdrawError(props.original.error)}>
            <span className="text-large text-info">
              <i className="icon-Information mx-2"/>
            </span>
          </ToolTip>
          :
          null
        }
      </div>,
    },
    {
      Header: t('Date'),
      accessor: 'timestamp',
      width: 160,
      Cell: props => <span>{i18nizeDate(props.value)}</span>,
      filterable: true,
      Filter: this.renderDateFilter,
    },
    {
      Header: t('Actions'),
      accessor: 'status',
      width: 100,
      Cell: props =>
        <div className='d-flex flex-row align-items-center justify-content-around'>
          {application.supportV2 && props.value === "ACCEPTED" &&
            <Rbac permission='delete_user-withdraws'>
              <ToolTip id={`cancel_${props.original.id}`} text={t('Cancel Withdraw')}>
                <i
                  className="icon-Close text-danger text-one font-weight-bold cursor-pointer"
                  onClick={async () => {await this.cancelWithdraw(props.original.id, props.original.userId);}}
                />
              </ToolTip>
            </Rbac>
          }
          <ToolTip id={`view_${props.original.id}`} text={t('View Profile')}>
            <Link to={{
              pathname: '/dashboard/users/' + props.original.userId,
            }}>
              <i className="simple-icon-eye view-icon text-large"/>
            </Link>
          </ToolTip>
        </div>,
    },
  ];

  renderTokenFilter({filter, onChange}) {
    const {t} = this.props;
    const options = values(this.tokens).map(token => ({
      value: token.symbol, label: token.localeName,
    }));
    return <ReactTableSelectFilter
      filter={filter}
      onChange={onChange}
      options={[
        {value: '', label: t('all')},
        ...options,
      ]}
    />;
  }

  renderStatusFilter({filter, onChange}) {
    const {t} = this.props;
    const options = [
      {value: '', label: t('all')},
      {value: 'ACCEPTED', label: t('Accepted')},
      {value: 'SUBMITTED', label: t('Registered')},
      {value: 'PENDING', label: t('Pending')},
      {value: 'CONFIRMED', label: t('Confirmed')},
      {value: 'REJECTED', label: t('Rejected')},
    ];
    return <ReactTableSelectFilter
      filter={filter}
      onChange={onChange}
      options={options}
    />;
  }

  renderDateFilter({onChange}) {
    const {selectedStartDate, selectedEndDate} = this.state;
    return <ReactTableDateFilter
      onChange={onChange}
      handleDateChange={this.handleDateChange}
      selectedStartDate={selectedStartDate}
      selectedEndDate={selectedEndDate}
    />;
  }

  cancelWithdraw = async (tnxId, userId) => {
    const {t} = this.props;
    try {
      await Api.invoke('DELETE', `/v2/admin-ui/withdraws/${tnxId}`, {
        userId,
      });
      NotificationManager.success(t('Withdraw transaction canceled successfully'), t('Message'));
      this.fetchWithdraws(this.table.state);
    } catch (e) {
      console.log("error: ", e);
    }
  };

  refreshList = async () => {
    const {t} = this.props;
    this.setState({refreshing: true});
    await this.fetchWithdraws(this.table.state);
    this.setState({refreshing: false});
    NotificationManager.info(t('Withdraws list updated successfully'), t('Message'));
  };

  openOutputModal = () => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Withdraws Excel Output'),
      body: <WithdrawsOutputForm/>,
    });
  };

  handleDateChange = (type, date) => {
    this.setState({
      [type]: date,
    });
  };

  onExpanded = (newExpanded, index) => {
    this.setState({
      expanded: {
        ...this.state.expanded,
        [index[0]]: !!newExpanded[index[0]],
      },
    });
  };

  updateList = (index, params) => {
    const {withdraws} = this.state;
    let list = [...withdraws];
    list.splice(index, 1, {...withdraws[index], ...params});
    this.setState({withdraws: list});
  };

  render() {
    const {t, match} = this.props;
    const {withdraws, pages, loading, expanded, refreshing} = this.state;
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <CardTitle className="d-flex flex-row justify-content-end align-items-center">
                  <Button
                    outline
                    color='success'
                    className="d-flex align-items-center justify-content-center mr-2"
                    onClick={this.openOutputModal}>
                    <i className="icon-File-Excel text-large"/>
                    <span className="mx-1">{t('Excel output')}</span>
                  </Button>
                  <Button
                    outline
                    disabled={refreshing || loading}
                    className="d-flex align-items-center justify-content-center"
                    onClick={this.refreshList}>
                    <i className='icon-File-Refresh text-large'/>
                    <span className="mx-1">{t('Refresh')}</span>
                  </Button>
                </CardTitle>
                <ReactTable
                  manual
                  ref={el => {this.table = el;}}
                  className="-highlight"
                  data={withdraws}
                  pages={pages}
                  loading={loading}
                  sortable={false}
                  resizable={true}
                  expanded={expanded}
                  onPageChange={() => {this.setState({expanded: {}});}}
                  onExpandedChange={this.onExpanded}
                  onFetchData={this.fetchData}
                  columns={this.getColumns(t)}
                  defaultPageSize={25}
                  style={{
                    width: '100%'
                  }}
                  {...reactTableText}
                  SubComponent={row => {
                    const {original} = row;
                    return (
                      <TransactionDetails
                        transaction={{
                          ...original,
                          type: 'withdraw',
                          index: row.index
                        }}
                        updateList={this.updateList}
                      />
                    );
                  }}
                />
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
  }
}

export default withTranslation()(List);
